<template>
  <div class="radios-group">
    <div
      class="radio-container"
      :class="optionWidthClass"
      :key="`radio_${i}`"
      v-for="(option, i) in computedOptions"
    >
      <input
        :id="$id(underSlugify(option.label))"
        :name="$id(underSlugify(name))"
        type="radio"
        :value="option.value"
        v-model="computedValue"
      />
      <label :for="$id(underSlugify(option.label))">{{ option.label }}</label>
    </div>
  </div>
</template>

<script>
import UsesOptions from "../../elements/UsesOptions";

export default {
  name: "RadiosGroup",
  extends: UsesOptions,
  props: {
    name: String
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    optionsPerRow() {
      if (this.computedOptions && this.computedOptions.length) {
        if (this.computedOptions.length % 3 === 0) {
          return 3;
        }
      }
      return 2;
    },
    optionWidthClass() {
      return `w-1/${this.optionsPerRow}`;
    },
    isValid() {
      return (
        this.computedValue &&
        this.computedOptions.map(o => o.value).indexOf(this.computedValue) > -1
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.radios-group {
  @apply flex flex-wrap border border-lightgray py-3 px-4 bg-white;

  &.invalid {
    @apply border-red;
  }

  .radio-container {
    &.w-1\/3 {
      &:nth-child(n + 4) {
        @apply mt-2;
      }
    }

    &.w-1\/2 {
      &:nth-child(n + 3) {
        @apply mt-2;
      }
    }
  }
}
</style>
